import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import { useLocation, useNavigate } from "react-router-dom";

export const ModalPage = () => {

  const location = useLocation();

  const navigate = useNavigate();


  const handleCancel = () => {
    navigate(-1); // go back to background route
  };

  return <FullPageWrapper isModal_fpw={true} />
}

export default ModalPage